import { forwardRef, type Ref, type SVGProps } from "react";
const IconSpamFolderFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M28 7H15.46l-1.7-2.55a1 1 0 0 0-.83-.45H4a2 2 0 0 0-2 2v19a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2M16 23a6 6 0 0 1-3.59-1.2 5.8 5.8 0 0 1-1.21-1.21 6 6 0 0 1 8.39-8.39 5.8 5.8 0 0 1 1.21 1.21A6 6 0 0 1 16 23"
    />
    <path
      fill="currentColor"
      d="M13.64 20.57a4.28 4.28 0 0 0 5.93-5.93zM16 12.71a4.28 4.28 0 0 0-3.57 6.65l5.93-5.93a4.27 4.27 0 0 0-2.36-.72"
    />
  </svg>
);
const ForwardRef = forwardRef(IconSpamFolderFilledSVG);
ForwardRef.displayName = "IconSpamFolderFilled";
export { ForwardRef as IconSpamFolderFilled };
